import React from 'react';

import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.js';

/**
 * Skeleton component for SearchResults.
 * Matches the dimensions and layout of the SearchResults component.
 */
export const SearchResultsSkeleton: React.FC<{
  itemCount?: number;
}> = ({ itemCount = 9 }) => {
  return (
    <section className="SearchResults component">
      <div className="SearchResults__container container">
        {/* SearchBar skeleton */}
        <div className="SearchBar">
          <div className="SearchBar__container">
            {/* Title skeleton */}
            <Skeleton height={32} width={120} className="mb-comfy-md" />
            {/* Search input skeleton */}
            <Skeleton height={48} width={384} borderRadius="0.5rem" />
          </div>
        </div>

        {/* TabGroup skeleton */}
        <div className="flex gap-snug-sm mb-comfy-lg">
          <Skeleton height={40} width={100} borderRadius="0.5rem" />
          <Skeleton height={40} width={120} borderRadius="0.5rem" />
          <Skeleton height={40} width={90} borderRadius="0.5rem" />
        </div>

        {/* Search results list skeleton */}
        <div className="flex flex-col gap-comfy-md">
          {/* Results count skeleton */}
          <Skeleton height={20} width={200} />

          {/* Results list skeleton */}
          <div className="flex flex-col gap-comfy-sm">
            {Array.from({ length: itemCount }, (_, index) => (
              <div
                key={index}
                className="flex gap-comfy-md p-comfy-md border border-neutral-mild rounded-lg"
              >
                {/* Badge skeleton */}
                <Skeleton height={24} width={80} borderRadius="9999px" />
                {/* Content skeleton */}
                <div className="flex-1 flex flex-col gap-snug-sm">
                  <Skeleton height={24} width="80%" />
                  <Skeleton height={16} width="100%" />
                  <Skeleton height={16} width="90%" />
                </div>
              </div>
            ))}
          </div>

          {/* Pagination skeleton */}
          <div className="flex justify-center mt-comfy-lg">
            <div className="flex gap-snug-sm">
              <Skeleton height={48} width={48} borderRadius="0.5rem" />
              <Skeleton height={48} width={48} borderRadius="0.5rem" />
              <Skeleton height={48} width={48} borderRadius="0.5rem" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
